<div class="btn-group">
    <button *ngFor="let button of buttons; let i=index" (click)="emit(i+1)" type="button" class="btn-red-ol o-5" [class.active]="activeOpt===(i+1)">{{ button | titlecase}}</button>
</div>